module.exports = __webpack_public_path__ + "536ba7d1ec6366fe2424dd8f4e8c3db6.png";